import React, { Component, Fragment,setState } from 'react';
import { Link } from 'react-router-dom';
import { FaYoutube, FaInstagram, FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import { FiPhoneCall } from 'react-icons/fi';
import { Col, Form, InputGroup, Button } from 'react-bootstrap';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import { withStyles } from '@material-ui/core/styles';
import Fade from '@material-ui/core/Fade';
const styles = theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        
      },
      paper: {
        border: '2px solid #000',
        backgroundColor:'white',
		width:'100vh',
		boxShadow: "black 0px 0px 20px 5px",
        height:'100vh'
	  },
	  paperCareer: {
        border: '2px solid #000',
		backgroundColor:'white',
		boxShadow: "black 0px 0px 20px 5px",
        width:'100vh',
        height:'88vh'
      },
});
  
  
const SocialShare = [
	{ Social: <FaFacebookF />, link: 'https://www.facebook.com/' },
	{ Social: <FaInstagram />, link: 'https://www.instagram.com/' },
	{ Social: <FaYoutube />, link: 'https://youtube.com/' },
	{ Social: <FaLinkedinIn />, link: 'https://www.linkedin.com/' },


];
class Footer extends Component {

	constructor(props) {
        super(props);
        this.state = { OpenSupport: false,showCotactForm: false,OpenCareer: false, OpenPartner: false};
    }

	formDisplayHandler = () => {
		this.setState({
			showCotactForm: true,
		});
	};
	submitHandler = e => {
		e.preventDefault();
	};
	handleOpenSupport = () => {
		this.setState({ OpenSupport: true });
	  }
	handleCloseSupport = () => {
		this.setState({ OpenSupport: false });
	  }
	handleOpenCareer = () => {
		this.setState({ OpenCareer: true });
	  }
	handleCloseCareer = () => {
		this.setState({ OpenCareer: false });
	  }
	handleOpenPartner = () => {
		this.setState({ OpenPartner: true });
	  }
	handleClosePartner = () => {
		this.setState({ OpenPartner: false });
	  }
	render() {
		const { classes } = this.props;
		let form = null;
		if (this.state.showCotactForm) {
			form = (
				<Fragment>
					<Form noValidate onSubmit={this.submitHandler}>
						<Form.Row>
							<Form.Group as={Col} md='2' style={{margin:'0'}} controlId='validationFormik101'>
								<Form.Control type='text' name='firstName' placeholder='First Name' />
							</Form.Group>
							<Form.Group as={Col} md='2' style={{margin:'0'}} controlId='validationFormik102'>
								<Form.Control type='text' name='lastName' placeholder='Last Name' />
							</Form.Group>
							<Form.Group as={Col} md='2' style={{margin:'0'}} controlId='validationFormikUsername2'>
								<InputGroup>
									<Form.Control type='text' placeholder='Phone Number' aria-describedby='inputGroupPrepend' />
								</InputGroup>
							</Form.Group>
							<Form.Group as={Col} md='4' style={{margin:'0'}} controlId='validationFormikUsername2'>
								<InputGroup>
									<Form.Control type='date' placeholder='Desired Date' aria-describedby='inputGroupPrepend' />
								</InputGroup>
							</Form.Group>
							<Form.Group as={Col} md='2' style={{margin:'0'}}>
								<Button className='rn-btn btn-send-email' style={{ color: '#fff',border: '1px solid'}} type='submit'>
									Send
								</Button>
							</Form.Group>
						</Form.Row>
					</Form>
					<div className='container'>
						<div className='row'>
							<div className='col-lg-12 pt--30 pl--0'>
								<Link className='rn-btn' style={{color: '#000',border: '1px solid', backgroundColor:'#fff'}} to='/clientinformation'>
									Do it yourself Online
								</Link>
							</div>
						</div>
					</div>
				</Fragment>
			);
		}

		return (
			<React.Fragment>
				<div className='row' style={{ display: 'flex', justifyContent: 'space-around' }}>
					<div className='col-lg-12 col-md-12 col-sm-12 col-12'>
						<div className='footer-rn-address' style={{}}>
							<div className='icon'>
								<FiPhoneCall />
							</div>
							<div className='inner'>
								<h3 className='title text-center' style={{ fontSize: '45px', color: '#acacac' }}>
									Call us
								</h3>
								<h2 className='title text-center' style={{ textShadow: '2px 4px 10px #acacac' }}>
									<a href='tel:+16045952800'>604 595 2800</a>
								</h2>
								{/* <p><a href="tel:+856 325 652 984">+856 325 652 984</a></p> */}
							</div>
						</div>
					</div>
				</div>
				<footer className='footer-area'>
					<div className='footer-wrapper'>
						<div className='row align-items-end row--0'>
							<div className='col-lg-6'>
								<div className='footer-left'>
									<div className='inner'>
										<span style={{ color: 'white' }}>Ready To Do This</span>
										<h2 style={{ color: 'white' }}>
											Get your Free <br /> Estimate Today
										</h2>
										{!this.state.showCotactForm ? (
											<button onClick={this.formDisplayHandler} style={{ backgroundColor: 'white' }} type='button' className='rn-button-style--2' href='/contact'>
												<span style={{ color: 'black'}}>Contact Us</span>
											</button>
										) : null}
										{form}
									</div>
								</div>
							</div>
							<div className='col-lg-6'>
								<div className='footer-right' data-black-overlay='2'>
									<div className='row'>
										{/* Start Single Widget  */}
										<div className='col-lg-4 col-sm-4 col-12'>
											<div className='footer-link'>
												<h4>Useful Link</h4>
												<ul className='ft-link'>
													<li>
														<Link to='/about'>About</Link>
													</li>
													<li>
														<Link to='/services'>Services</Link>
													</li>
													<li>
														<Link to='/blogdetails'>Blog</Link>
													</li>
													<li>
														<Link to='/tips'>Tips</Link>
													</li>
													<li>
														<Link to='/contact'>Let's Talk</Link>
													</li>
												</ul>
											</div>
										</div>
										{/* End Single Widget  */}
										{/* Start Single Widget  */}
										<div className='col-lg-4 col-sm-6 col-12 mt_mobile--30'>
											<div className='footer-link'>
												<h4>Legal</h4>
												<ul className='ft-link'>
													<li>
														<Link href='/privacy'>Privacy</Link>
													</li>
													<li>
														<Link href='/termofuse'>Term of use</Link>
													</li>
												</ul>
											</div>
											<div className='footer-link'>
												<h4>Contact Us</h4>
												<ul className='ft-link'>
												<li>
												<Link onClick={this.handleOpenSupport}>
														Support
													</Link>
												</li>
													<Modal
                                                aria-labelledby="transition-modal-title"
                                                aria-describedby="transition-modal-description"
                                                className={classes.modal}
                                                open={this.state.OpenSupport}
                                                onClose={this.handleCloseSupport}
                                                closeAfterTransition
                                                BackdropComponent={Backdrop}
                                                BackdropProps={{
                                                timeout: 500,
                                                }}
                                            >
                                                <Fade in={this.state.OpenSupport}>
                                                <div className={classes.paper}>
                                                    <div className="text-center">                                                    
                                                    <h3 style={{fontSize:'30px',marginTop:'2rem'}} id="transition-modal-title">Have a Question? Let's help you</h3>
                                                    </div>
                                                    <Form style={{paddingLeft:'18vh',paddingRight:'18vh'}}>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>First Name</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter your First Name"  />
                                                        </Form.Group>

														<Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>Last Name</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter your First Name"  />
                                                        </Form.Group>

                                                        
                                                    </Form.Row>

                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>Email</Form.Label>
                                                        <Form.Control type="email" placeholder="Enter email" />
                                                        </Form.Group>

														<Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>Phone Number</Form.Label>
                                                        <Form.Control type="number" placeholder="Enter Phone Number" />
                                                        </Form.Group>

                                                       
                                                    </Form.Row>
													<Form.Group as={Col} controlId="formGridEmail" style={{padding:'0'}}>
                                                        <Form.Label><h3>Best time to callback</h3></Form.Label>
                                                        <Form.Group style={{width:'auto'}} controlId="formBasicCheckbox">
															<Form.Check type="checkbox" label="Morning" />
														</Form.Group>
														<Form.Group controlId="formBasicCheckbox">
															<Form.Check type="checkbox" label="Afternoon" />
														</Form.Group>
														<Form.Group controlId="formBasicCheckbox">
															<Form.Check type="checkbox" label="Evening" />
														</Form.Group>
                                                        </Form.Group>
                                                    <Form.Group controlId="exampleForm.ControlTextarea1">
                                                        <Form.Label>Details of Your Topic</Form.Label>
                                                        <Form.Control as="textarea" rows="3" />
                                                    </Form.Group>
                                                    <Form.Group controlId="formBasicCheckbox">
															<Form.Check style={{marginLeft:'2.5vh'}} type="checkbox" label="I agree to give my consent to call me back." />
														</Form.Group>

                                                    <div className="text-center pt--30">
                                                    <Button variant="primary" type="submit" style={{width:'13rem', border:'2px solid black',background:'#de2828'}}>
                                                        Submit
                                                    </Button>
													<h5 style={{fontSize:'12px',position:'absolute',bottom:'0%',left:'34%'}}>We work very hard to serve our clients, please give us 24-48 hours to call you back</h5>
                                                    </div>
                                                    </Form>
                                                	</div>
                                                	</Fade>
                                                	</Modal>
													<li>
													<Link  onClick={this.handleOpenCareer}>
														Career
													</Link>
													</li>
													<Modal
                                                aria-labelledby="transition-modal-title"
                                                aria-describedby="transition-modal-description"
                                                className={classes.modal}
                                                open={this.state.OpenCareer}
                                                onClose={this.handleCloseCareer}
                                                closeAfterTransition
                                                BackdropComponent={Backdrop}
                                                BackdropProps={{
                                                timeout: 500,
                                                }}
                                            >
                                                <Fade in={this.state.OpenCareer}>
                                                <div className={classes.paperCareer}>
                                                    <div className="text-center">                                                    
                                                    <h3 style={{fontSize:'30px',marginTop:'2rem'}} id="transition-modal-title">We are always Hiring the best!</h3>
                                                    </div>
                                                    <Form style={{paddingLeft:'18vh',paddingRight:'18vh'}}>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>First Name</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter your First Name"  />
                                                        </Form.Group>

														<Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>Last Name</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter your First Name"  />
                                                        </Form.Group>

                                                        
                                                    </Form.Row>

                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>Email</Form.Label>
                                                        <Form.Control type="email" placeholder="Enter email" />
                                                        </Form.Group>

														<Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>Phone Number</Form.Label>
                                                        <Form.Control type="number" placeholder="Enter Phone Number" />
                                                        </Form.Group>

                                                       
                                                    </Form.Row>
													
													<Form.Group controlId="exampleForm.ControlTextarea1">
                                                        <Form.Label><h5>Job Title</h5></Form.Label>
                                                        <Form.Control as="textarea" rows="1" />
                                                    </Form.Group>                                                    
													<Form.Group>
														<Form.Label><h5>Send your Cover Letter and Resume</h5></Form.Label>
														<Form.File id="exampleFormControlFile1" />
													</Form.Group>
                                                    <Form.Group controlId="formBasicCheckbox">
														<Form.Check style={{marginLeft:'2.5vh'}} type="checkbox" label="I agree to give my consent to call me back." />
													</Form.Group>

                                                    <div className="text-center pt--30">
                                                    <Button variant="primary" type="submit" style={{width:'13rem',background:'#de2828'}}>
                                                        Submit
                                                    </Button>
													<h5 style={{fontSize:'12px',position:'absolute',bottom:'5%',left:'34%'}}>We work very hard to serve our clients, please give us 24-48 hours to call you back</h5>
                                                    </div>
                                                    </Form>
                                                	</div>
                                                	</Fade>
                                                	</Modal>
													<li>
													<Link  onClick={this.handleOpenPartner}>
														Affiliates & Partners
														</Link>
													</li>
													<Modal
                                                aria-labelledby="transition-modal-title"
                                                aria-describedby="transition-modal-description"
                                                className={classes.modal}
                                                open={this.state.OpenPartner}
                                                onClose={this.handleClosePartner}
                                                closeAfterTransition
                                                BackdropComponent={Backdrop}
                                                BackdropProps={{
                                                timeout: 500,
                                                }}
                                            >
                                                <Fade in={this.state.OpenPartner}>
                                                <div className={classes.paperCareer}>
                                                    <div className="text-center">                                                    
                                                    <h3 style={{fontSize:'30px',marginTop:'2rem'}} id="transition-modal-title">Join Our Affiliates and Partners Program</h3>
													<h4 style={{fontSize:'25px',marginTop:'1rem'}}>Have the Desire to make money? Let’s talk!</h4>
                                                    </div>
                                                    <Form style={{paddingLeft:'18vh',paddingRight:'18vh'}}>
                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>First Name</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter your First Name"  />
                                                        </Form.Group>

														<Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>Last Name</Form.Label>
                                                        <Form.Control type="text" placeholder="Enter your First Name"  />
                                                        </Form.Group>

                                                        
                                                    </Form.Row>

                                                    <Form.Row>
                                                        <Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>Email</Form.Label>
                                                        <Form.Control type="email" placeholder="Enter email" />
                                                        </Form.Group>

														<Form.Group as={Col} controlId="formGridEmail">
                                                        <Form.Label>Phone Number</Form.Label>
                                                        <Form.Control type="number" placeholder="Enter Phone Number" />
                                                        </Form.Group>

                                                       
                                                    </Form.Row>
													
													<Form.Group controlId="exampleForm.ControlTextarea1">
                                                        <Form.Label><h5>Let’s know how you can help us</h5></Form.Label>
                                                        <Form.Control as="textarea" rows="3" />
                                                    </Form.Group>                                                    
													 <Form.Group controlId="formBasicCheckbox">
														<Form.Check style={{marginLeft:'2.5vh'}} type="checkbox" label="I agree to give my consent to call me back." />
													</Form.Group>

                                                    <div className="text-center pt--30">
                                                    <Button variant="primary" type="submit" style={{width:'13rem',background:'#de2828'}}>
                                                        Submit
                                                    </Button>
													<h5 style={{fontSize:'12px',position:'absolute',bottom:'5%',left:'34%'}}>To become and affiliate or partner, we don’t guarantee any income. Affiliates and <br/>Partners are sole contractors and they won’t be considered as employees of our company.</h5>
                                                    </div>
                                                    </Form>
                                                	</div>
                                                	</Fade>
                                                	</Modal>
												</ul>
											</div>
										</div>
										{/* End Single Widget  */}

										<div className='col-lg-4 col-sm-6 col-12 mt_mobile--30'>
											<div className='social-share-inner'>
											<div className='footer-link'>
											<h4>Social Links</h4>
												<ul className='social-share social-style--2 d-flex justify-content-start liststyle mt--15'>
													{SocialShare.map((val, i) => (
														<li key={i}>
															<a href={`${val.link}`}>{val.Social}</a>
														</li>
													))}
												</ul>
											</div>
											</div>
											<div className='footer-link'>
												<h4 className='pt--20'>Head Office</h4>
												<ul className='ft-link'>
													<li>
														<Link to='/contact'>700 - 838 W. Hastings St. Vancouver BC V6C 0A6</Link>
													</li>
												</ul>
											</div>
										</div>

										<div className='col-lg-12'>
											<div className='copyright-text'>
												<p>Copyright © 2020 Moonline Moving Ltd.</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</footer>
			</React.Fragment>
		);
	}
}
export default withStyles(styles)(Footer);
